import { ComponentProps } from 'react';

import { ReactComponents, ReactComponentType } from 'strapi/component/types';

import { MediaComponent } from '../component/shared/types';

import { AiWritingToolChildStrapiPage } from './aiWritingToolChildPage';
import { AiWritingToolParentStrapiPage } from './aiWritingToolParentPage';
import { CreateLibraryStrapiPage } from './createLibraryPage';
import { CreateSubUseCaseStrapiPage } from './createSubUseCasePage';
import { CreateUseCaseStrapiPage } from './createUseCasePage';
import { MockupChildStrapiPage } from './mockupChildPage';
import { MockupParentStrapiPage } from './mockupParentPage';
import { TemplatesSubUseCaseStrapiPage } from './templatesSubUseCasePage';
import { TemplatesUseCaseStrapiPage } from './templatesUseCasePage';
import { ToolsLibraryStrapiPage } from './toolsLibraryPage';

export enum PageType {
  CreateLibraryPage = 'CreateLibraryPage',
  CreateUseCasePage = 'CreateUseCasePage',
  CreateSubUseCasePage = 'CreateSubUseCasePage',
  TemplatesUseCasePage = 'TemplatesUseCasePage',
  TemplatesSubUseCasePage = 'TemplatesSubUseCasePage',
  MockupParentPage = 'MockupParentPage',
  MockupChildPage = 'MockupChildPage',
  AiWritingToolParentPage = 'AiWritingToolParentPage',
  AiWritingToolChildPage = 'AiWritingToolChildPage',
  ToolsLibraryPage = 'ToolsLibraryPage',
}

export interface Category {
  name: string;
  use_cases: UseCase[];
}

export interface UseCase {
  name: string;
  slug: string;
  category: Category;
  sub_use_cases: SubUseCase[];
  create_use_case_page: CreateUseCaseStrapiPage;
}

export interface SubUseCase {
  name: string;
  slug: string;
  use_case: UseCase;
  create_sub_use_case_page: CreateSubUseCaseStrapiPage;
}

export interface CommonPageProps {
  path: string;
  showBreadcrumbs: boolean;
  updatedAt: string;
}

export interface ToolsPageProps extends CommonPageProps {
  slug: string;
  cover: MediaComponent;
  descriptiveName: string;
}

export interface PageWithDescriptionsProps extends CommonPageProps {
  slug: string;
  cover: MediaComponent;
  descriptiveName: string;
  pageDescription: string;
}

export type PageTypes =
  | CreateLibraryStrapiPage
  | CreateUseCaseStrapiPage
  | CreateSubUseCaseStrapiPage
  | TemplatesUseCaseStrapiPage
  | TemplatesSubUseCaseStrapiPage
  | MockupParentStrapiPage
  | MockupChildStrapiPage
  | AiWritingToolParentStrapiPage
  | AiWritingToolChildStrapiPage
  | ToolsLibraryStrapiPage;

export interface LandingPageStrapiParams {
  component: ReactComponentType;
  props: ComponentProps<ReactComponents>;
}

export interface LandingPageStrapiProps {
  params: LandingPageStrapiParams[];
}
